import { useTranslation } from 'react-i18next';

import type { RecapListEntry } from '@/api/generated/schemas.ts';

// What the recap is called before (or without) an extracted title: its first email's subject, else a placeholder,
// which says so while it's being drafted. A version, or a recap without its sources, has only its title.
const useRecapTitle = () => {
    const { t } = useTranslation();
    return (recap: Pick<RecapListEntry, 'title'> & Partial<Pick<RecapListEntry, 'sources' | 'extraction_status'>>) =>
        recap.title ??
        recap.sources?.find((source) => source.email?.subject)?.email?.subject ??
        (recap.extraction_status === 'processing' ? t('recaps.processingTitle') : t('recaps.untitled'));
};

export default useRecapTitle;
